import React, { Component } from 'react';

import Combo from './Combo';

class Telefonos extends Component {
    constructor(props) {
        super(props);
    } 

    render() { 

        const {data, esModificacion} = this.props;
        const {validaCamposEdicion} = data;

        let disablePrepaga = !(data.tiposCuentaDisponibles != "TC" && data.tiposProductoPermitidosModificacion != "TC");
        let disableCredito = !(data.tiposCuentaDisponibles != "TP" && data.tiposProductoPermitidosModificacion != "TP");
        
        
        return (  
        <div className='modalTelefonosInterior'>
            <div className='bottom-separator modalTelefonosEncabezado'>
                {!esModificacion ? <h1>Carga de un nuevo teléfono</h1> : <h1>Modificación de teléfono</h1>}
                <label onClick={()=>this.props.funcionModalConfirmador("abrir","TELEFONICO")} className='ti-close clickable'></label>
            </div>
            <div className='modalTelefonosCuerpo'>

                <Combo validaCamposEdicion={validaCamposEdicion.tipoTelefono} mensajeErrorValidacion={"Debe ingresar un  tipo de teléfono"} campo={'tipoTelefonoEnEdicion'} titulo={"Tipo de Teléfono"} infoData={data.tiposComunicacion} selectCombo={this.props.funcionEdicion} selecciones ={data}/>
                
                <div className={"inputModificacionTelefono " + (validaCamposEdicion.telefono ? "bottom-separator-marca" : "bottom-separator-xxs")}>
                    <label className="label-primary">{'Número'}</label>
                    <input maxLength={10} value={data.telefonoEnEdicion} onChange={(e)=>this.props.funcionEdicion("telefonoEnEdicion",e.target.value)} placeholder={"Ingrese teléfono"} type='text'></input>
                    {validaCamposEdicion.validarRegistros == false && <label className='error'>El teléfono ya se encuentra registrado</label>}
                    {validaCamposEdicion.telefono == false && validaCamposEdicion.validarRegistros && <label className='error'>Debe ingresar un teléfono válido</label>}   
                </div>

                <div className=''>
                    <label className="label-primary">{'Producto'}</label>
                    <div className="contenedorDatosProceso">
                        <div className="inlineListItem2 lg-margin">
                        <div className="contenedorCheckboxTelefono default-checkbox">
                                <input disabled={disablePrepaga} id={"check-tipoProducto-Prepaga"} type="checkbox" checked={data.checkProductoPrepaga} onChange={(e)=>this.props.funcionModificarCheck("checkProductoPrepaga")}  />
                                <label className={"label-primary " +( !disablePrepaga ? "" : "disabledGrey") } htmlFor={"check-tipoProducto-Prepaga"}></label>
                        </div>
                        <label className="label-primary headerConfirmadorDenegar" htmlFor={"check-tipoProducto-Prepaga"}>Prepaga</label>
                        </div>
                        <div className="inlineListItem2 lg-margin">
                        <div className="contenedorCheckboxTelefono default-checkbox">
                                <input disabled={disableCredito} id={"check-tipoProducto-Credito"} type="checkbox" checked={data.checkProductoCredito} onChange={(e)=>this.props.funcionModificarCheck("checkProductoCredito")}  />
                                <label className={"label-primary " +( !disableCredito ? "" : "disabledGrey") } htmlFor={"check-tipoProducto-Credito"}></label>
                            </div>
                            <label className="label-primary headerConfirmadorDenegar" htmlFor={"check-tipoProducto-Credito"}>Crédito</label>
                        </div>
                    </div>
                    {validaCamposEdicion.tipoProducto == false && <label className='error'>Debe ingresar un teléfono válido</label>}
                </div>
            </div>

            <div className='footerTelefonosModal'>
                <button onClick={()=>this.props.funcionModalConfirmador("abrir","TELEFONICO")} className='btn btn-secondary'>Cancelar</button>
                <button onClick={()=>this.props.funcionAceptar("TELEFONO",esModificacion)} className='btn btn-cta'>Aceptar</button>
            </div>
        </div>
       );
    }   
}
export default Telefonos;